// This is a helper function that returns whether or not the browser is IE11
export function isIE11(): boolean {
  return (
    window != null &&
    (window as any).MSInputMethodContext != null &&
    (document as any).documentMode != null
  );
}
